import productGroupFields from "./productGroupFields";
import { applyFrench } from "@lib/applyFrenchField";

const internalLink = `
  _type == "internalLink" => {
    "id": @.reference->_id,
    "type": @.reference->_type,
    "slug": @.reference->slug,
    "handle": @.reference->store.slug.current,
    "productGroup": *[_type == "product" && ^.reference->_id == _id] {
      "data": *[_type=="productPage" && references(^._id) ] {
        ${productGroupFields}
      }
    }[0],
  },
`;

const link = `
  link,
  "refTitle": document->title,
  "type": document->_type,
  "handle": document->store.slug.current,
  "slug": document->slug,
  "productGroup": *[_type=="productPage" && references(^.document->_id) ] {
    ${productGroupFields}
  },
`;

const richTextField = `${applyFrench(
  `content[] {
    ...,
    markDefs[]{
      ...,
      ${internalLink}
    }
  }`,
  `content_fr.richTextContent[] {
    ...,
    markDefs[]{
      ...,
      ${internalLink}
    }
  }`
)}`;

const titleWithBody = `
  _type == "titleWithBody" => {
    ...,
    "title": ${applyFrench("title", "title_fr")},
    body {
      ...,
      "content": ${richTextField}
    }
  },
`;

const richTextWithHeader = `
  _type == "richTextWithHeader" => {
    ...,
    "header": ${applyFrench("header", "header_fr")},
    richText {
      ...,
      "content": ${richTextField}
    }
  },
`;

const gallery = `
  _type == "gallery" => {
    ...,
    "header": ${applyFrench("header", "header_fr")},
    media[] {
      ...,
      link {
        ...,
        ${link}
      },
      text {
        ...,
        "content": ${richTextField}
      },
      videoSrc {
        ...,
        asset->{
          ...,
          "url": "https://stream.mux.com/" + playbackId
        }
      }
    }
  },
`;

const stats = `
  _type == "stats" => {
    ...,
    "header": ${applyFrench("header", "header_fr")},
    statsList[] {
      ...,
      "statNumber": ${applyFrench("statNumber", "statNumber_fr")},
      "statText": ${applyFrench("statText", "statText_fr")},
    },
  },
`;

const pageBuilderFields = `
  pageBuilderComponents[] {
    ...,
    ${titleWithBody}
    ${richTextWithHeader}
    ${gallery}
    ${stats}
  }
`;

export default pageBuilderFields;
